import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import styled from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { HighlightedProductsHeaderConfig } from 'pricing-pages-ui/constants/merchCards/HighlightedProductsHeaderConfig';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap } from '../../constants/BusinessObjectivesTranslationKeys';
import { FREE_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import ProductIcon from '../common/ProductIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResponsiveFlex = styled.div.withConfig({
  displayName: "HorizontalFreeCard__ResponsiveFlex",
  componentId: "sc-19duquf-0"
})(({
  theme
}) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.space[300],
    [trellisBreakpoint.sdMac]: {
      flexDirection: 'column',
      gap: theme.space[1000]
    }
  };
});
export const HorizontalFreeCard = ({
  productLine
}) => {
  const productLevel = FREE;
  const isAppReady = useGlobalLoading();
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(ResponsiveFlex, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          flexGrow: 1,
          children: [/*#__PURE__*/_jsx(SectionTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "merchCards.freeCard.title"
            })
          }), /*#__PURE__*/_jsx(SectionSubTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: HighlightedProductsHeaderConfig[productLine][FREE].subtitle
            })
          }), /*#__PURE__*/_jsx(PPUIGrid, {
            gridTemplateColumns: "1fr 1fr 1fr",
            rowGap: "300",
            children: AllCombinedProductLines.map(localProductLine => /*#__PURE__*/_jsxs(Flex, {
              justifyContent: "start",
              alignItems: "center",
              flexWrap: "nowrap",
              children: [/*#__PURE__*/_jsx(ProductIcon, {
                name: localProductLine,
                iconStyle: {
                  blockSize: '16px',
                  marginInlineEnd: '100'
                }
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
              })]
            }, localProductLine))
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "end",
          gap: "300",
          children: [/*#__PURE__*/_jsx(SkeletonLoadWrapper, {
            isLoading: !isAppReady,
            heights: [47],
            widths: ['100%'],
            children: /*#__PURE__*/_jsx(SignupButton, {
              sourceId: "pricing-hero",
              productLine: productLine,
              use: "secondary",
              nonMerchandiseIdProduct: 'crm',
              trackingSource: FREE_CARD
            })
          }), /*#__PURE__*/_jsx(View, {
            maxInlineSize: "140px",
            children: /*#__PURE__*/_jsx(Text, {
              as: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "merchCards.freeCard.subtexts.seats"
              })
            })
          })]
        })]
      })
    })
  });
};